/* Licensing Solutions — shared behaviour */
(function () {
  'use strict';

  /* ---------- Desktop dropdowns ---------- */
  const nav = document.getElementById('nav');
  if (nav) {
    const items = Array.from(nav.querySelectorAll(':scope > li'));
    const closeAll = (except) => items.forEach((li) => {
      if (li !== except) { li.classList.remove('open'); const b = li.querySelector(':scope > button'); if (b) b.setAttribute('aria-expanded', 'false'); }
    });
    items.forEach((li) => {
      const btn = li.querySelector(':scope > button');
      if (!btn) return;
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        const open = li.classList.toggle('open');
        btn.setAttribute('aria-expanded', String(open));
        closeAll(li);
      });
      li.addEventListener('mouseenter', () => { closeAll(li); li.classList.add('open'); btn.setAttribute('aria-expanded', 'true'); });
      li.addEventListener('mouseleave', () => { li.classList.remove('open'); btn.setAttribute('aria-expanded', 'false'); });
    });
    document.addEventListener('click', () => closeAll(null));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeAll(null); });
  }

  /* ---------- Mobile drawer ---------- */
  const drawer = document.getElementById('drawer');
  if (drawer) {
    const open = () => { drawer.hidden = false; drawer.classList.add('open'); document.body.style.overflow = 'hidden'; drawer.querySelector('[data-drawer-close]').focus(); };
    const close = () => { drawer.classList.remove('open'); drawer.hidden = true; document.body.style.overflow = ''; };
    document.querySelectorAll('[data-drawer-open]').forEach((b) => b.addEventListener('click', open));
    drawer.querySelectorAll('[data-drawer-close]').forEach((b) => b.addEventListener('click', close));
    drawer.querySelectorAll('a').forEach((a) => a.addEventListener('click', close));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !drawer.hidden) close(); });
  }

  /* ---------- Explained carousel ---------- */
  document.querySelectorAll('.carousel').forEach((c) => {
    const track = c.querySelector('.carousel__track');
    const dots = c.querySelector('.carousel__dots');
    const prev = c.querySelector('[data-dir="-1"]');
    const next = c.querySelector('[data-dir="1"]');
    const cards = Array.from(track.children);
    const perView = () => Math.max(1, Math.round(track.clientWidth / cards[0].getBoundingClientRect().width));
    const pages = () => Math.ceil(cards.length / perView());
    const page = () => Math.round(track.scrollLeft / track.clientWidth);
    const goTo = (p) => track.scrollTo({ left: p * track.clientWidth, behavior: 'smooth' });
    const buildDots = () => {
      dots.innerHTML = '';
      for (let i = 0; i < pages(); i++) {
        const d = document.createElement('button'); d.type = 'button'; d.setAttribute('aria-label', 'Page ' + (i + 1));
        d.addEventListener('click', () => goTo(i)); dots.appendChild(d);
      }
      sync();
    };
    const sync = () => {
      const p = page(), n = pages();
      dots.querySelectorAll('button').forEach((d, i) => d.setAttribute('aria-current', String(i === p)));
      prev.disabled = p <= 0; next.disabled = p >= n - 1;
    };
    prev.addEventListener('click', () => goTo(page() - 1));
    next.addEventListener('click', () => goTo(page() + 1));
    let t; track.addEventListener('scroll', () => { clearTimeout(t); t = setTimeout(sync, 80); });
    window.addEventListener('resize', buildDots);
    buildDots();
  });

  /* ---------- Reveal on scroll ---------- */
  const reveals = document.querySelectorAll('.reveal');
  if (reveals.length && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    reveals.forEach((el, i) => { el.style.transitionDelay = (i % 3) * 60 + 'ms'; io.observe(el); });
    setTimeout(() => reveals.forEach((el) => el.classList.add('in')), 1500); // safety net
  } else {
    reveals.forEach((el) => el.classList.add('in'));
  }

  /* ---------- Sample quiz (home page) ---------- */
  const quiz = document.getElementById('quiz');
  if (quiz) {
    const QUESTIONS = [
      { q: 'What is the minimum age at which a person may be sold alcohol on licensed premises in England and Wales?', opts: ['16', '18', '21', '25'], a: 1,
        why: 'It is an offence to sell alcohol to anyone under 18, and the licence holder can be prosecuted.' },
      { q: 'How many licensing objectives are set out in the Licensing Act 2003?', opts: ['Two', 'Three', 'Four', 'Five'], a: 2,
        why: 'The four objectives: preventing crime and disorder, public safety, preventing public nuisance, and protecting children from harm.' },
      { q: 'A premises licence that authorises the sale of alcohol must specify a…', opts: ['Door supervisor', 'Designated Premises Supervisor', 'Licensing officer', 'Duty manager'], a: 1,
        why: 'Every premises selling alcohol must name a Designated Premises Supervisor (DPS), who must hold a personal licence.' },
    ];
    const qEl = document.getElementById('quiz-q');
    const optsEl = document.getElementById('quiz-opts');
    const resEl = document.getElementById('quiz-result');
    const nextBtn = document.getElementById('quiz-next');
    const nEl = document.getElementById('quiz-n');
    const doneEl = document.getElementById('quiz-done');
    let idx = 0;

    const render = () => {
      const item = QUESTIONS[idx];
      nEl.textContent = idx + 1;
      qEl.textContent = item.q;
      resEl.textContent = '';
      nextBtn.hidden = true;
      if (doneEl) doneEl.hidden = true;
      optsEl.innerHTML = item.opts.map((o, i) =>
        '<button type="button" class="quiz__opt" data-i="' + i + '"><span class="key">' + 'ABCD'[i] + '</span><span>' + o + '</span></button>'
      ).join('');
    };
    optsEl.addEventListener('click', (e) => {
      const btn = e.target.closest('.quiz__opt');
      if (!btn || btn.disabled) return;
      const item = QUESTIONS[idx];
      const picked = Number(btn.dataset.i);
      optsEl.querySelectorAll('.quiz__opt').forEach((b, i) => {
        b.disabled = true;
        if (i === item.a) b.classList.add('is-correct');
        else if (i === picked) b.classList.add('is-wrong');
      });
      resEl.innerHTML = (picked === item.a ? '<b>Correct.</b> ' : '<b>Not quite.</b> ') + item.why;
      const last = idx === QUESTIONS.length - 1;
      nextBtn.hidden = last;
      if (doneEl) doneEl.hidden = !last; // after the final sample, point to the full mock exam
    });
    nextBtn.addEventListener('click', () => { idx = (idx + 1) % QUESTIONS.length; render(); });
    const restart = document.getElementById('quiz-restart');
    if (restart) restart.addEventListener('click', () => { idx = 0; render(); qEl.focus && quiz.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); });
    render();
  }

  /* ---------- Mock exam answers: hide / reveal ---------- */
  const qaGrid = document.getElementById('qa-grid');
  const qaToggle = document.getElementById('qa-toggle');
  if (qaGrid && qaToggle) {
    const status = document.getElementById('qa-status');
    qaToggle.addEventListener('click', () => {
      const hide = !qaGrid.classList.contains('is-hidden');
      qaGrid.classList.toggle('is-hidden', hide);
      qaGrid.querySelectorAll('.qa.is-revealed').forEach((q) => q.classList.remove('is-revealed'));
      qaToggle.textContent = hide ? 'Show all answers' : 'Hide answers';
      qaToggle.setAttribute('aria-pressed', String(hide));
      status.textContent = hide ? 'Answers hidden. Click a question to reveal its answer.' : 'Correct answers are highlighted. Hide them to test yourself.';
    });
    qaGrid.addEventListener('click', (e) => {
      const card = e.target.closest('.qa');
      if (card && qaGrid.classList.contains('is-hidden')) card.classList.toggle('is-revealed');
    });
  }

  /* ---------- Match the heights of paired notes in two-column panels ---------- */
  const pairNotes = () => {
    document.querySelectorAll('.split, .service').forEach((split) => {
      const notes = [...split.querySelectorAll(':scope > .split__col > .callout, :scope > div > .callout.svc-foot')];
      notes.forEach((n) => { n.style.minHeight = ''; });
      if (notes.length < 2 || window.matchMedia('(max-width: 1024px)').matches) return;
      const tallest = Math.max(...notes.map((n) => n.offsetHeight));
      notes.forEach((n) => { n.style.minHeight = tallest + 'px'; });
    });
  };
  pairNotes();
  window.addEventListener('resize', pairNotes);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(pairNotes);

  /* ---------- Copy discount code ---------- */
  document.querySelectorAll('.coupon__copy').forEach((btn) => {
    btn.addEventListener('click', async () => {
      const code = btn.dataset.copy;
      try { await navigator.clipboard.writeText(code); btn.textContent = 'Copied'; }
      catch (e) { btn.textContent = code; }
      setTimeout(() => { btn.textContent = 'Copy'; }, 1800);
    });
  });

  /* ---------- Enquiry form ---------- */
  const enquiry = document.getElementById('enquiry-form');
  if (enquiry) {
    enquiry.addEventListener('submit', (e) => {
      // Inside the Shopify theme this is a real contact form, so let it post once valid
      const native = enquiry.dataset.native === 'true' || /\/contact/.test(enquiry.getAttribute('action') || '');
      if (!native) e.preventDefault();
      const name = enquiry.querySelector('#eq-name'), email = enquiry.querySelector('#eq-email');
      const nameMissing = name.required && !name.value.trim();
      if (nameMissing || !email.checkValidity() || !email.value.trim()) {
        if (native) e.preventDefault();
        (nameMissing ? name : email).focus();
        return;
      }
      if (native) return;
      enquiry.querySelectorAll('.field-wrap, .btn, .enquiry__note').forEach((el) => { el.hidden = true; });
      document.getElementById('enquiry-done').hidden = false;
    });
  }

  /* ---------- Header: shrink on scroll (hysteresis so it never flickers at the threshold) ---------- */
  const siteHeader = document.querySelector('.header');
  if (siteHeader) {
    const onScroll = () => {
      const y = window.scrollY;
      if (y > 80) siteHeader.classList.add('is-scrolled');
      else if (y < 10) siteHeader.classList.remove('is-scrolled');
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Booking page: sticky buy panel ----------
     A panel taller than the viewport would pin with its buttons off-screen,
     so anchor it to the bottom of the viewport instead. */
  const buyPanel = document.querySelector('.buy');
  if (buyPanel) {
    const GAP = 24;
    const setTop = () => {
      if (getComputedStyle(buyPanel).position !== 'sticky') { buyPanel.style.top = ''; return; }
      const h = buyPanel.offsetHeight;
      const vh = window.innerHeight;
      const HEADER = (document.querySelector('.header')?.offsetHeight || 84) + 16;
      buyPanel.style.top = (h + HEADER + GAP > vh) ? (vh - h - GAP) + 'px' : HEADER + 'px';
    };
    setTop();
    window.addEventListener('resize', setTop);
    if ('ResizeObserver' in window) new ResizeObserver(setTop).observe(buyPanel);
  }

  // Shop base: absolute on the static preview, relative when running inside the Shopify theme
  const SHOP = typeof window.LS_SHOP_BASE === 'string' ? window.LS_SHOP_BASE : 'https://licensing-solutions.co.uk';

  /* ---------- Booking page: price calculator ---------- */
  const form = document.getElementById('buy-form');
  if (form) {
    const d = form.dataset;
    // Application service is advertised as £125 + VAT. It is made up of our own fee, which is
    // vatable, plus two disbursements (DBS and the council fee) that carry no VAT.
    const EXAM = Number(d.exam || 75), VAT = 0.2, APPLY_NET = Number(d.apply || 125);
    const SERVICE = Number(d.service || 76.25), DBS = Number(d.dbs || 21.5), COUNCIL = Number(d.council || 37);
    const SERVICE_LABEL = d.serviceLabel || 'Licensing Solutions application service';
    const COUNCIL_LABEL = d.councilLabel || 'Licensing authority fee';
    const WAS = Number(d.was || 125), MAX = Number(d.max || 50);
    const ITEM = d.item || 'BIIAB APLH exam';
    const APPLY_SUB = d.applySub || 'Includes VAT, DBS and council fees';
    // Optional direct Shopify cart: data-variants maps "candidates|self/apply" to a variant id
    const variants = d.variants ? JSON.parse(d.variants) : null;
    const idInput = form.querySelector('input[name="id"]');
    const qty = form.querySelector('#candidates');
    const out = document.getElementById('total-amount');
    const sub = document.getElementById('total-sub');
    const rows = document.getElementById('summary-rows');
    const now = document.getElementById('price-now');
    const was = document.getElementById('price-was');
    const save = document.getElementById('price-save');
    const add = document.getElementById('price-add');
    const what = document.getElementById('summary-what');
    const money = (v) => '£' + v.toFixed(2);
    const update = () => {
      const n = Number(qty.value) || 1;
      const svc = form.querySelector('input[name="service"]:checked');
      const apply = !!svc && svc.value === 'apply';
      // The charged total follows the Shopify variant: (exam + £125) + 20% VAT.
      const total = (EXAM + (apply ? APPLY_NET : 0)) * n * (1 + VAT);

      // Headline price: exam fee before VAT, scaled by candidates
      now.textContent = money(EXAM * n);
      was.textContent = money(WAS * n);
      save.textContent = n > 1 ? 'Save ' + money((WAS - EXAM) * n) : 'Flash sale price';
      if (add) add.hidden = !apply;
      if (add && apply) {
        add.innerHTML = '+ ' + money(APPLY_NET * n) +
          ' <small>application service, + VAT</small>';
      }

      // Itemised summary
      const people = n + (n === 1 ? ' candidate' : ' candidates');
      const lines = [[ITEM + ' × ' + n, EXAM * n]];
      if (apply) lines.push(['Application service × ' + n, APPLY_NET * n]);
      const subtotal = lines.reduce((t, l) => t + l[1], 0);
      lines.push(['Subtotal <small>(ex VAT)</small>', subtotal, 'sub']);
      lines.push(['VAT (20%)', total - subtotal]);
      if (what) what.textContent = people + ' × exam' + (apply ? ' + application service' : '');
      rows.innerHTML = lines.map((l) =>
        '<div class="summary__row' + (l[2] === 'sub' ? ' summary__row--sub' : '') + '"><dt>' + l[0] + '</dt><dd>' + money(l[1]) + '</dd></div>'
      ).join('');

      // Both options advertise what they add to the exam, before VAT: nothing for
      // "apply myself", the application service for "apply for me".
      form.querySelectorAll('.choice__price').forEach((el) => {
        const b = el.querySelector('b');
        if (!b) return;
        b.textContent = '+ ' + money(el.dataset.price === 'apply' ? APPLY_NET * n : 0);
      });

      const wasTotal = (WAS + (apply ? APPLY_NET : 0)) * n * (1 + VAT);
      out.innerHTML = '<s class="summary__was">' + money(wasTotal) + '</s>' + money(total);
      sub.textContent = apply ? APPLY_SUB : 'Includes VAT';

      // Keep the cart variant / buy now link in sync
      if (variants && idInput) idInput.value = variants[n + '|' + (apply ? 'apply' : 'self')] || idInput.value;
      const buyNow = form.querySelector('[data-buy-now]');
      if (buyNow && idInput) {
        const q = variants ? 1 : n;
        buyNow.href = SHOP + '/cart/' + idInput.value + ':' + q;
      }
    };
    form.querySelectorAll('.stepper__btn').forEach((btn) => btn.addEventListener('click', () => {
      const v = Math.min(MAX, Math.max(1, (Number(qty.value) || 1) + Number(btn.dataset.step)));
      qty.value = v; update();
    }));
    qty.addEventListener('input', () => {
      if (qty.value !== '' && Number(qty.value) < 1) qty.value = 1;
      if (Number(qty.value) > MAX) qty.value = MAX;
      update();
    });
    form.addEventListener('change', update);
    update();
  }
})();
